import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import {
  Col,
  DatePicker,
  Form,
  Modal,
  Pagination,
  Row,
  Spin,
  message,
} from "antd";
import BillingService from "../../../Services/BillingService";
import { FaFilter } from "react-icons/fa6";
import moment from "moment";
import { useForm } from "antd/es/form/Form";
import PatientService from "../../../Services/PatientService";
import PatientQueue from "../VCPage/PatientQueue";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import dayjs from "dayjs";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import { IoIosCloseCircle } from "react-icons/io";
import Draggable from "react-draggable";
import NoDataFound from "../../../Assets/Icons/NoDataCard2.svg";

function BillingReports() {
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const [tableData, setTableData] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [apiPayload, setApiPayload] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form, setForm] = useForm();
  const [isVerticalOpen, setIsVerticalOpen] = useState(true);
  const [formData, setFormData] = useState({
    patientName: "",
    patientId: "",
    transactionId: "",
  });

  useEffect(() => {
    getRecordList();
  }, []);

  const formatDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const getRecordList = () => {
    setLoading(true);
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month + 1, 0);

    setFromDate(formatDate(firstDate));
    setToDate(formatDate(lastDate));

    const payload = {
      userId: loginResultObject.user.userId,
      clinic_id: loginResultObject.user.clinic_Id,
      statuses: "1,4",
      fromDate: formatDate(firstDate),
      toDate: formatDate(lastDate),
      pageNo: 1,
    };

    setApiPayload(payload);

    Promise.all([
      BillingService.BillingRecordsList(payload),
      BillingService.BillingCount(payload),
    ])
      .then(([recordsRes, countRes]) => {
        setTableData(recordsRes.data);
        setPage(countRes.data.TOTAL_COUNT_STATUS);
      })
      .catch((error) => {
        console.error("Error fetching billing data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    getRecordList();
    form.resetFields();
    setFormData({
      patientName: "",
      patientId: "",
      transactionId: "",
    });
  };

  const handleFinish = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month + 1, 0);

    setFromDate(formatDate(firstDate));
    setToDate(formatDate(lastDate));

    const { patientId, patientName, transactionId } = formData;

    if (!patientName && !transactionId && !patientId) {
      message.error("Enter Any Details to filter");
      return;
    }
    let payload = {
      ...formData,
      statuses: "1,4",
      userId: loginResultObject.user.userId,
      clinic_id: loginResultObject.user.clinic_Id,
      pageNo: 1,
      fromDate: formatDate(firstDate),
      toDate: formatDate(lastDate),
    };
    setApiPayload(payload);

    BillingService.BillingRecordsList(payload)
      .then((res) => {
        setTableData(res.data);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });

    BillingService.BillingCount(payload)
      .then((res) => {
        setPage(res.data.TOTAL_COUNT_STATUS);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });
    handleOk();
  };

  const handleMonthFilter = (value) => {
    const formattedDate = "01";
    const formattedMonth = value.format("MM");
    const formattedYear = value.format("YYYY");
    const fromDate = `${formattedMonth}/${formattedDate}/${formattedYear}`;
    const fromDateMoment = moment(fromDate, "MM/DD/YYYY");
    const lastDayOfMonth = fromDateMoment.endOf("month").format("MM/DD/YYYY");
    const toDate = lastDayOfMonth;
    setFromDate(fromDate);
    setToDate(toDate);

    let payload = {
      userId: loginResultObject.user.userId,
      clinic_id: loginResultObject.user.clinic_Id,
      fromDate: fromDate,
      toDate: toDate,
      statuses: "1,4",
      pageNo: 1,
    };

    setApiPayload(payload);

    BillingService.BillingRecordsList(payload)
      .then((res) => {
        setTableData(res.data);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });

    BillingService.BillingCount(payload)
      .then((res) => {
        setPage(res.data.TOTAL_COUNT_STATUS);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });
  };

  const onClose = () => {
    setIsDrawerOpen(false);
  };
  const showDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handlePageChange = (pageNo) => {
    apiPayload.pageNo = pageNo;
    apiPayload.fromDate = fromDate;
    apiPayload.toDate = toDate;
    let payload = apiPayload;

    BillingService.BillingRecordsList(payload)
      .then((res) => {
        setTableData(res.data);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });

    if (apiPayload.pageNo == 1) {
      BillingService.BillingCount(payload)
        .then((res) => {
          setPage(res.data.TOTAL_COUNT_STATUS);
        })
        .catch((error) => {
          console.error("Error fetching billing records:", error);
        });
    }
  };

  const convertUTCDateLocal = (utcDate) => {
    const localDate = dayjs.utc(utcDate).local();
    return {
      date: localDate.format("DD/MM/YYYY"),
      time: localDate.format("hh:mm A"),
    };
  };

  const handleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };

  return (
    <Layouts>
      {isModalOpen && (
        <Modal
          title="Filter"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[]}
        >
          <Form
            className="formDesign"
            name="trigger"
            layout="vertical"
            form={form}
            onFinish={handleFinish}
          >
            <Row gutter={20} className="mt-2">
              <div className="flex">
                <Col span={12}>
                  <div className="relative  w-full">
                    <input
                      type="text"
                      id="patientname"
                      placeholder=""
                      name="patientName"
                      value={formData.patientName}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }
                      className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0  "
                    />
                    <label
                      htmlFor="patientname"
                      className="absolute left-3 -top-3  text-[#189FAA] bg-white px-1 transition-all 
                peer-placeholder-shown:top-1   peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
                peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
                    >
                      Patient Name
                    </label>
                  </div>
                </Col>

                <Col span={12}>
                  <div className="relative w-full  ">
                    <input
                      type="text"
                      id="patientId"
                      placeholder=""
                      name="patientId"
                      value={formData.patientId}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }
                      className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
                    />
                    <label
                      htmlFor="patientId"
                      className="absolute left-3 -top-3 text-[#189FAA] bg-white px-1 transition-all 
                peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
                peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
                    >
                      Patient ID
                    </label>
                  </div>
                </Col>
              </div>

              <Col span={12}>
                <div className="relative w-full mt-4">
                  <input
                    type="text"
                    id="transactionId"
                    name="transactionId"
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                    placeholder=""
                    value={formData.transactionId}
                    className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
                  />
                  <label
                    htmlFor="transactionId"
                    className="absolute left-3 -top-3 text-[#189FAA] bg-white px-1 transition-all 
                peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
                peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
                  >
                    Transaction ID
                  </label>
                </div>
              </Col>
            </Row>

            <Form.Item>
              <div className="flex justify-end  border-brand-colorBorder gap-3 pt-2">
                <button
                  className="h-[32px] Btnwhite rounded-sm w-[82px] border-gray-600 border-2"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="h-[32px] w-[118px] text-white rounded-sm bg-brand-primaryColor"
                  type="primary"
                  onClick={handleFinish}
                  htmlType="submit"
                >
                  Filter
                </button>
              </div>
            </Form.Item>
          </Form>
        </Modal>
      )}
      <div className="flex flex-col h-full ">
        <div className="md:flex justify-between">
          <div className="font-bold my-2 ">Billing Reports</div>
          <div className="flex gap-2 mt-[20px]">
            <DatePicker
              onChange={handleMonthFilter}
              picker="month"
              format="MMM YYYY"
              defaultValue={dayjs()}
              allowClear={false}
            />
            <div className="flex ml-4 items-center justify-end">
              <button
                className="text-white font-semibold p-2 rounded-md flex items-center bg-brand-primaryColor"
                onClick={showModal}
              >
                <FaFilter className="mr-1" />
                Filter
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="flex justify-center items-center mt-40">
            <Spin />
          </div>
        ) : (
          <div className="w-full overflow-x-auto overflow-y-hidden">
            {tableData && tableData.length > 0 ? (
              <table className="w-full border border-gray-200 shadow-md rounded-md customTable mt-4">
                <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
                  <tr className="font-sans font-normal">
                    <th className="p-3 whitespace-nowrap">Patient</th>
                    <th className="p-3 whitespace-nowrap">Service ID</th>
                    <th className="p-3 whitespace-nowrap">Type of Service</th>
                    <th className="p-3 whitespace-nowrap">Transaction ID</th>
                    <th className="p-3 whitespace-nowrap">Paid Date</th>
                    <th className="p-3 whitespace-nowrap">Mode Of Payment</th>
                    <th className="p-3 whitespace-nowrap">Amount</th>
                    <th className="p-3 whitespace-nowrap">Discount Amount</th>
                    <th className="p-3 whitespace-nowrap">Paid Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((record, index) => (
                    <tr
                      key={index}
                      className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                    >
                      <td className="p-3 whitespace-nowrap">
                        <div className="flex flex-col">
                          <span>{record.patientName}</span>
                          <span className="text-brand-textDarkgray text-xs mb-0">
                            {record.patientId}
                          </span>
                        </div>
                      </td>
                      <td className="p-3 whitespace-nowrap align-top">
                        {record.serviceTransId}
                      </td>
                      <td className="p-3 whitespace-nowrap align-top">
                        {record.serviceName}
                      </td>
                      <td className="p-3 whitespace-nowrap align-top">
                        {record.transactionId}
                      </td>
                      <td className="p-3 whitespace-nowrap">
                        <div>
                          {convertUTCDateLocal(record.paymentDate).date}
                        </div>
                        <div className="text-xs">
                          {convertUTCDateLocal(record.paymentDate).time}
                        </div>
                      </td>
                      <td className="p-3 whitespace-nowrap align-top">
                        {record.paymode}
                      </td>
                      <td className="p-3 whitespace-nowrap align-top">
                        {record.amount}
                      </td>
                      <td className="p-3 whitespace-nowrap align-top">
                        {record.discountAmount}
                      </td>
                      <td className="p-3 whitespace-nowrap align-top">
                        {record.paidAmount}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="flex justify-center items-center">
                <img src={NoDataFound} alt="No Data" className="h-[20rem]" />
              </div>
            )}
          </div>
        )}
        <div className="flex justify-end items-end my-4">
          <Pagination
            onChange={handlePageChange}
            defaultCurrent={1}
            total={page}
            showSizeChanger={false}
          />
        </div>
      </div>
      {/* patient queue design */}
      {isVerticalOpen ? (
        <Draggable>
          <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
            <div
              className="hidden md:block relative mb-5 cursor-pointer"
              onClick={closeCircle}
            >
              <IoIosCloseCircle className="hidden md:block text-red-400 absolute mb-1 right-0 top-0" />
            </div>
            <img
              src={patientqueue}
              alt="patientqueue"
              className="cursor-pointer"
              title="Patient Queue"
              onClick={showDrawer}
            />
          </div>
        </Draggable>
      ) : (
        <div
          className="vertical"
          style={{ marginTop: "16rem" }}
          onClick={handleClick}
        >
          <p className="vertical-p">
            <div className="vertical-icon-dashboard">
              <MdKeyboardDoubleArrowUp />
            </div>
            Queue
          </p>
        </div>
      )}

      {isDrawerOpen && (
        <div className="grid justify-end mt-5">
          {isDrawerOpen && <PatientQueue onClose={onClose} />}
        </div>
      )}
      {/* patient queue design end */}
    </Layouts>
  );
}

export default BillingReports;
